import React from "react";
import { Input } from "../../ui/inputs/Input";
import { useProductionStore } from "../../../stores/production";

const Period = () => {
  const { formData, setFormData } = useProductionStore();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="w-full flex justify-start items-center gap-4 ">
      <Input
        label="Date de début"
        name="startDate"
        value={formData.startDate || ""}
        onChange={handleChange}
        type="date"
        clasName="w-52 font-Nunito"
      />
      <Input
        label="Date de fin"
        name="endDate"
        value={formData.endDate || ""}
        onChange={handleChange}
        type="date"
        clasName="w-52 font-Nunito"
      />
    </div>
  );
};

export default Period;
